/**
 * Para onde cada papel vai depois de entrar.
 *
 * É tabela e não condicional de propósito. A forma anterior era
 *
 *     const dest = user?.role === 'STUDENT' ? '/student' : '/dashboard';
 *
 * — uma LISTA DE RECUSA, em que todo papel que não fosse aluno caía no painel do
 * professor. Funcionava com três papéis; com `SCHOOL_STAFF` mandaria a equipe
 * gestora para um painel que não é dela, cheio de itens que respondem 403.
 *
 * É a mesma forma que produziu o achado 69, e trocá-la agora é barato: papel
 * novo que ninguém acrescentar aqui cai no destino neutro, e o produto pede
 * ajuda em vez de fingir que sabe o que fazer.
 */
export const DESTINO_POR_PAPEL: Record<string, string> = {
  ADMIN: '/dashboard',
  TEACHER: '/dashboard',
  STUDENT: '/student',
  SCHOOL_STAFF: '/gestao',
};

/** Destino de quem entrou. Papel desconhecido vai para a raiz, não para o painel de outro. */
export const destinoDe = (papel?: string): string =>
  (papel && DESTINO_POR_PAPEL[papel]) || '/';

/**
 * A ÁREA INICIAL de cada papel (24/10/2026): para onde vai quem chega numa área que não é a do seu papel — o caso da troca de
 * conta, em que a tela aberta é de outro papel. Antes ia para "/" (a página pública): trocar de professor para administrador
 * caía lá, porque a rota do professor redirecionava antes de a navegação da troca chegar.
 */
export const AREA_DO_PAPEL: Record<string, string> = {
  ADMIN: '/admin',
  TEACHER: '/teacher',
  STUDENT: '/student',
  SCHOOL_STAFF: '/gestao',
};
export const areaDe = (papel?: string): string => (papel && AREA_DO_PAPEL[papel]) || '/';
